// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.3/node_modules/css-loader/dist/cjs.js??clonedRuleSet-45.use[1]!../../node_modules/.pnpm/webfonts-loader@8.1.1/node_modules/webfonts-loader/index.js!./icon.font.js");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../node_modules/.pnpm/vue-style-loader@4.1.3/node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("2b77835c", content, true, {});